import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

const ProfileCard = ({ data, onChangeImage, uploading = false }) => {
    const { societyName, brandName, profileImage, city, state } = data || {};
    const location = [city, state].filter(Boolean).join(", ");

    return (
        <div className="tw-mb-4 tw-rounded-xl tw-bg-white tw-border tw-border-slate-200 tw-shadow-sm">
            {/* Gradient Banner */}
            <div className="tw-h-16 tw-bg-gradient-to-r tw-from-amber-400 tw-via-amber-500 tw-to-orange-500 tw-relative tw-rounded-t-xl">
                <div className="tw-absolute tw-inset-0 tw-opacity-10 tw-rounded-t-xl" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'40\' height=\'40\' viewBox=\'0 0 40 40\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'%23fff\' fill-opacity=\'0.3\' fill-rule=\'evenodd\'%3E%3Cpath d=\'M0 40L40 0H20L0 20M40 40V20L20 40\'/%3E%3C/g%3E%3C/svg%3E")' }} />
            </div>

            <div className="tw-px-5 tw-pb-4 tw--mt-7 tw-relative">
                <div className="tw-flex tw-items-end tw-gap-3.5">
                    {/* Profile Image */}
                    <div className="tw-relative tw-flex-shrink-0">
                        <div className="tw-w-14 tw-h-14 tw-rounded-lg tw-border-3 tw-border-white tw-bg-white tw-shadow-md tw-flex tw-items-center tw-justify-center tw-overflow-hidden" style={{ borderWidth: '3px' }}>
                            {profileImage ? (
                                <img
                                    src={profileImage}
                                    alt={societyName}
                                    className="tw-w-full tw-h-full tw-object-cover"
                                />
                            ) : (
                                <Icon
                                    icon="solar:buildings-2-bold-duotone"
                                    className="tw-text-2xl tw-text-amber-400"
                                />
                            )}
                        </div>
                        <button
                            type="button"
                            onClick={onChangeImage}
                            disabled={uploading}
                            title={uploading ? "Uploading..." : "Change logo"}
                            className="tw-absolute tw--bottom-1 tw--right-1 tw-w-5 tw-h-5 tw-rounded-full tw-bg-amber-500 tw-flex tw-items-center tw-justify-center tw-shadow-sm tw-border-2 tw-border-white hover:tw-bg-amber-600 disabled:tw-opacity-60 disabled:tw-cursor-wait tw-transition-colors tw-cursor-pointer"
                        >
                            {uploading ? (
                                <div className="tw-w-2 tw-h-2 tw-border tw-border-white tw-border-t-transparent tw-rounded-full tw-animate-spin" />
                            ) : (
                                <Icon icon="solar:camera-bold" className="tw-text-white" style={{ fontSize: '9px' }} />
                            )}
                        </button>
                    </div>

                    {/* Society Info */}
                    <div className="tw-flex-1 tw-min-w-0 tw-pb-0.5">
                        <div className="tw-flex tw-items-center tw-gap-2 tw-mb-0.5">
                            <h2 className="tw-text-base tw-font-bold tw-text-slate-800 tw-truncate">
                                {societyName || "Society Name"}
                            </h2>
                            {brandName && (
                                <span className="tw-px-2 tw-py-0.5 tw-rounded-full tw-bg-amber-50 tw-text-amber-600 tw-text-[10px] tw-font-semibold tw-border tw-border-amber-100 tw-flex-shrink-0">
                                    {brandName}
                                </span>
                            )}
                        </div>
                        {location && (
                            <div className="tw-flex tw-items-center tw-gap-1 tw-text-slate-500 tw-text-xs">
                                <Icon icon="solar:map-point-bold" className="tw-text-amber-400 tw-text-sm" />
                                <span>{location}</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileCard;
